//Custom components
import StatCard from '../../../UI/Card/StatCard';

const AverageProjectGrant = ({ count }: { count: number | string }) => {
  return <StatCard title='Average Project Grant' stat={`$ ${count}`} />;
};

export default AverageProjectGrant;
